import React, { useState, useRef } from "react";
import CodeExecutor from "../../../../components/CodeExecutor/CodeExecutor.js";
import {
  Card,
  Row,
  Col,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  CardFooter,
  Container
} from "reactstrap";
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import { CheckCode } from "./CheckCode.js";
import MainFooter from "../../../../components/Footers/MainFooter.js";

import classnames from "classnames";
import { useLesson } from "../../../../hooks/lessonFramework.js";
import { useUserAuth } from "../../../../context/UserContext.js";
import NavigationButton from "../../../../components/NavigationButton/NavigationButton.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardUser, faSquareCheck, faRobot } from "@fortawesome/free-solid-svg-icons";

import { CODESNIPPET } from "../../../../constants/codeSnippet.js";
import Highlight, { defaultProps } from "prism-react-renderer";
import github from "prism-react-renderer/themes/github";
import AIAssistant from "pages/AI/AIAssistant.js";

const PrintStatementsComponent = () => {
  const lessonID = "JA101";
  const { lessonCode, setInitialCode } = useLesson();
  const mainRef = useRef(null);
  const { user } = useUserAuth();
  const [activeTab, setActiveTab] = useState("1");

  //   setInitialCode(`public class Main {
  //   public static void main(String[] args) {

  //     System.out.println("Hello, Java!");

  //     System.out.println("This will be printed.");

  //     System.out.println("This should not be printed.");
  //   }
  // }`)

  const executeTests = (code, output) => {
    const newCheckedStates = CheckCode(code, output, checkedStates, user, lessonID);
    updateCheckboxState(newCheckedStates);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // CHECKBOXS
  const [checkedStates, setCheckedStates] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
  });

  // Function to update the state of specific checkboxes
  const updateCheckboxState = (updates) => {
    setCheckedStates((prevState) => ({
      ...prevState,
      ...updates, // Merge the updates into the current state
    }));
  };
  // CHECKBOXS

  return (
    <>
      <div className=" lessonBackgroundColor1 lessonMain  h-100vh" >
        <LessonNavBar />
        <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
          <section>
            <Container fluid className=" pr-0 pl-0   fullWitdthHeight ">
              <CodeExecutor languageCode="java" initialCode={lessonCode} runTestCase={executeTests}>
                <Card className="fullWitdthHeight">
                  <CardHeader className=" lesson-header">Print Statements</CardHeader>
                  <TabContent className="fullWitdthHeight overflow-auto " activeTab={activeTab}>
                    <TabPane className="fullWitdthHeight" tabId="1">
                      <CardBody>
                        <CardTitle tag="h5">
                          What Is a Print Statement
                        </CardTitle>
                        <CardText>
                          A print statement is used to display messages, numbers, or other information to the screen. In Java, there are two main types of print statements: System.out.println() and System.out.print().
                        </CardText>
                        <CardTitle tag="h5">
                          Using System.out.println()
                        </CardTitle>
                        <CardText>
                          The System.out.println() statement prints text or other values and moves to a new line after printing.
                        </CardText>
                        <CardText>
                          Example:
                        </CardText>
                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsCode1} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>
                        <CardText>
                          Output:
                        </CardText>
                        <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsOutput1} language="java">
                          {({ style, tokens, getLineProps, getTokenProps }) => (
                            <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                              {tokens.map((line, i) => (
                                <div key={i} {...getLineProps({ line, key: i })}>
                                  {line.map((token, key) => (
                                    <span key={key} {...getTokenProps({ token, key })} />
                                  ))}
                                </div>
                              ))}
                            </pre>
                          )}
                        </Highlight>
                        <CardTitle tag="h5">
                          Using System.out.print()
                        </CardTitle>
                        <CardText>
                          The System.out.print() statement is similar to System.out.println() but does not move to a new line after printing.
                        </CardText>
                        <CardText>
                          Example:
                        </CardText>
                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsCode2} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>
                        <CardText>
                          Output:
                        </CardText>
                        <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsOutput2} language="java">
                          {({ style, tokens, getLineProps, getTokenProps }) => (
                            <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                              {tokens.map((line, i) => (
                                <div key={i} {...getLineProps({ line, key: i })}>
                                  {line.map((token, key) => (
                                    <span key={key} {...getTokenProps({ token, key })} />
                                  ))}
                                </div>
                              ))}
                            </pre>
                          )}
                        </Highlight>
                        <CardTitle tag="h5">
                          Printing Text and Numbers
                        </CardTitle>
                        <CardText>
                          {'To print text, you must enclose it in double quotes (""). This tells Java to treat the text as plain words that you want to display on the screen.'}
                        </CardText>
                        <CardText>
                          Example:
                        </CardText>
                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsCode3} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>
                        <CardText>
                          Output:
                        </CardText>
                        <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsOutput3} language="java">
                          {({ style, tokens, getLineProps, getTokenProps }) => (
                            <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                              {tokens.map((line, i) => (
                                <div key={i} {...getLineProps({ line, key: i })}>
                                  {line.map((token, key) => (
                                    <span key={key} {...getTokenProps({ token, key })} />
                                  ))}
                                </div>
                              ))}
                            </pre>
                          )}
                        </Highlight>

                        <CardText>
                          {'To print numbers, you can directly pass them without quotes.'}
                        </CardText>
                        <CardText>
                          Example:
                        </CardText>
                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsCode4} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>
                        <CardText>
                          Output:
                        </CardText>
                        <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsOutput4} language="java">
                          {({ style, tokens, getLineProps, getTokenProps }) => (
                            <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                              {tokens.map((line, i) => (
                                <div key={i} {...getLineProps({ line, key: i })}>
                                  {line.map((token, key) => (
                                    <span key={key} {...getTokenProps({ token, key })} />
                                  ))}
                                </div>
                              ))}
                            </pre>
                          )}
                        </Highlight>
                        <CardText>
                          {'You can also use System.out.println() to perform and display mathematical calculations.'}
                        </CardText>
                        <CardText>
                          Example:
                        </CardText>
                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsCode5} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>
                        <CardText>
                          Output:
                        </CardText>
                        <Highlight {...defaultProps} theme={github} code={CODESNIPPET.PrintStatementsOutput5} language="java">
                          {({ style, tokens, getLineProps, getTokenProps }) => (
                            <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                              {tokens.map((line, i) => (
                                <div key={i} {...getLineProps({ line, key: i })}>
                                  {line.map((token, key) => (
                                    <span key={key} {...getTokenProps({ token, key })} />
                                  ))}
                                </div>
                              ))}
                            </pre>
                          )}
                        </Highlight>
                      </CardBody>
                    </TabPane>

                    <TabPane tabId="2">
                      <CardBody>
                        {/* CHECKBOXS */}
                        <h4>Try It Yourself</h4>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox1"
                                checked={checkedStates.checkbox1}
                                readOnly
                              />
                              Problem 1
                            </Label>
                          </FormGroup>
                        </div>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox2"
                                checked={checkedStates.checkbox2}
                                readOnly
                              />
                              Problem 2
                            </Label>
                          </FormGroup>
                        </div>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox3"
                                checked={checkedStates.checkbox3}
                                readOnly
                              />
                              Problem 3
                            </Label>
                          </FormGroup>
                        </div>
                        {/* CHECKBOXS */}
                      </CardBody>
                    </TabPane>
                    <TabPane tabId="3">
                      <CardBody>
                        <AIAssistant></AIAssistant>
                      </CardBody>
                    </TabPane>
                  </TabContent>
                  <CardFooter className=" lesson-footer">
                    <Nav tabs className="justify-content-center my-nav-tabs ">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "1" })}
                          onClick={() => toggle("1")}
                        >
                          <FontAwesomeIcon icon={faChalkboardUser} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => toggle("2")}
                        >
                          <FontAwesomeIcon icon={faSquareCheck} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "3" })}
                          onClick={() => toggle("3")}
                        >
                          <FontAwesomeIcon icon={faRobot} size="lg" />
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </CardFooter>
                </Card>
              </CodeExecutor>
            </Container>
          </section>
          <section >
            <Container className="container-lg">
              <Row className=" p-3   align-items-center  justify-content-between">
                <NavigationButton direction="back" page="basicStructure"></NavigationButton>
                <NavigationButton direction="next" page="comments"></NavigationButton>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    </>
  );
};

export default PrintStatementsComponent;
